import { useTranslation } from 'react-i18next';
import { FormGroup, FormControlLabel, Checkbox, Typography, Alert } from '@mui/material';
import { parseHtmlOrNull } from 'helpers/htmlParser';
import PrimaryButton from 'components/Common/PrimaryButton';

type BiasOverlayProps = {
    isVisible: boolean;
    isAck: boolean;
    hasBias: boolean;
    biasReason: string;
    onShowOutput: () => void;
    onAck: (isAck: boolean) => void;
};

export const BiasOverlay = ({
    isVisible,
    isAck,
    hasBias,
    biasReason,
    onShowOutput,
    onAck,
}: BiasOverlayProps) => {
    const { t } = useTranslation();
    const hideOverlay = !isVisible || !hasBias;

    if (hideOverlay) {
        return <></>;
    }

    return (
        <div className="bias-overlay">
            <Alert variant="outlined" severity="warning" className="bias-overlay-alert">
                <Typography variant="body1" fontWeight={600}>
                    {t('web_app.bias_checker.bias_detected')}
                </Typography>
                <br />
                <div className="bias-overlay-content">
                    <Typography variant="body1" component="div">
                        {parseHtmlOrNull(biasReason)}
                        <br />
                        <p>{t('web_app.bias_checker.reason')}</p>
                    </Typography>
                </div>
            </Alert>
            <FormGroup className="bias-overlay-form">
                <FormControlLabel
                    control={<Checkbox checked={isAck} onChange={() => onAck(!isAck)} />}
                    label={t('web_app.bias_checker.acknowledge_text')}
                />
            </FormGroup>
            <div className="bias-overlay-btn">
                <PrimaryButton
                    text={t('web_app.bias_checker.show_output')}
                    className="filled"
                    onClick={onShowOutput}
                    disabled={!isAck}
                />
            </div>
        </div>
    );
};
